import { Injectable } from '@angular/core';
import { Tag } from '../../domain/models/tag.model';
import { TagDto } from '../dtos/tag.dto';

@Injectable({ providedIn: 'root' })
export class TagMapper {
  public toTag(dto: TagDto): Tag {
    return {
      id: dto.Id,
      text: dto.Text,
      backgroundColor: dto.BackgroundColor ?? null,
      foregroundColor: dto.ForegroundColor ?? null,
      inClient: dto.InClient,
      inPatient: dto.InPatient,
    };
  }
}
